import React, { Component } from "react";
import { connect } from "react-redux";
import { DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import styles from "./Pirate.css";
import { DND_PIRATE } from "../../constants";
import Pirate from "../Pirate/Pirate";
import { getPlayerPirate } from "../../reducers/user/selectors";
import { setPlayerPiratePos } from "../../reducers/user/actions";

const mapStateToProps = state => ({
  pirate: getPlayerPirate(state)
});

const mapDispatchToProps = dispatch => ({
  setPos: (x, y) => dispatch(setPlayerPiratePos({ x, y }))
});

const dragSource = {
  beginDrag: props => props,
  endDrag: (props, monitor) => {
    const { pirate: { x, y }, setPos } = props;
    const { x: initialX, y: initialY } = monitor.getInitialClientOffset();
    const { x: offsetX, y: offsetY } = monitor.getClientOffset();

    // Calculate percentile change and update pos in state
    setPos(x * (offsetX / initialX), y * (offsetY / initialY));
  }
};

const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
});

@connect(mapStateToProps, mapDispatchToProps)
@DragSource(DND_PIRATE, dragSource, collect)
export default class PirateContainer extends Component {
  componentDidMount = () => {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true
    });
  };

  render = () =>
    this.props.connectDragSource(
      <div
        onClick={this.handleClick}
        className={`${styles.draggable} ${this.props.isDragging &&
          styles.isDragging}`}
        style={{
          left: `${this.props.pirate.x * 100}%`,
          top: `${this.props.pirate.y * 100}%`
        }}
      >
        <Pirate {...this.props} />
      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/Pirate/PirateContainer.js